import { useQueryClient } from '@tanstack/react-query';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
export const useUpdateActivityLogPreferences = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutationState({
        mutationFn: (param)=>{
            let { showSentNotifications, updatedAt } = param;
            return api.activityLog.savePreferences({
                showSentNotifications,
                updatedAt
            });
        },
        onMutate: (param)=>{
            let { showSentNotifications } = param;
            var _ref;
            queryClient.cancelQueries({
                queryKey: [
                    QueryKeys.ActivityLogPreferences
                ]
            });
            const previous = queryClient.getQueryData([
                QueryKeys.ActivityLogPreferences
            ]);
            queryClient.setQueryData([
                QueryKeys.ActivityLogPreferences
            ], {
                showSentNotifications,
                updatedAt: (_ref = previous === null || previous === void 0 ? void 0 : previous.updatedAt) !== null && _ref !== void 0 ? _ref : null
            });
        },
        onSuccess: (saved)=>{
            queryClient.setQueryData([
                QueryKeys.ActivityLogPreferences
            ], saved);
        },
        onError: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ActivityLogPreferences
                ]
            });
        }
    });
    return {
        save: mutate,
        isLoading
    };
};
